<template>
  <div>
    <ForYouComponent />
  </div>
</template>

<script>
import ForYouComponent from './components/Index.vue'

export default {
  name: 'ForYou',
  components: {
    ForYouComponent,
  },
}
</script>
